import QCollapse from './src/QCollapse.vue';

/* istanbul ignore next */
QCollapse.install = function(Vue) {
  Vue.component(QCollapse.name, QCollapse);
};

export default QCollapse;
